
import Table from './Table';
const Tab2 = ({pageState,setPageState,accounts}) => {

  return (
     <div>
            <div className="px-3" style={{ background: 'white' }}>
              
                <div className="mb-3" >

                    <div className="col-md-12 px-2" style={{ display: 'flex', gap: '20px' }} >
                        <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px', border: '1px solid #DBDBDB', borderRadius: '5px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Default Payable Account</p>
                                </div>
                            </div>

                        

 <Table
  accounts={{
    value: pageState.accounts || [],
    setValue: (val) =>
      setPageState({
        ...pageState,
        accounts: val,
      }),
  }}
/>



                        </div>
                    </div>

                </div>
            
            </div>

        </div >
  )
}

export default Tab2